export const getDomainStyle = async (assetsUrl: string) => {
	try {
		const data = await fetch(`${assetsUrl}domain.css`)
		const style = await data.text()
		return style
	} catch (error) {
		throw new Error('Error missing domain style')
	}
}
